module.exports = __webpack_public_path__ + "img/img_4654.cfc5edbf.jpg";